module.exports = __webpack_public_path__ + "img/horses-mouth.54a67925.png";